/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Live_TitleInputs */

const en_us2_quick_workout_live_title = /** @type {(inputs: Quick_Workout_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workout is running`)
};

const pt_br2_quick_workout_live_title = /** @type {(inputs: Quick_Workout_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há um treino em andamento`)
};

const es_419_quick_workout_live_title = /** @type {(inputs: Quick_Workout_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay un entrenamiento en curso`)
};

const pt_pt2_quick_workout_live_title = /** @type {(inputs: Quick_Workout_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há um treino a decorrer`)
};

const fr_fr2_quick_workout_live_title = /** @type {(inputs: Quick_Workout_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une séance est en cours`)
};

const de_de2_quick_workout_live_title = /** @type {(inputs: Quick_Workout_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Training läuft`)
};

const it_it2_quick_workout_live_title = /** @type {(inputs: Quick_Workout_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'è un allenamento in corso`)
};

/**
* | output |
* | --- |
* | "A workout is running" |
*
* @param {Quick_Workout_Live_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_live_title = /** @type {((inputs?: Quick_Workout_Live_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Live_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_live_title(inputs)
	if (locale === "es-419") return es_419_quick_workout_live_title(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_live_title(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_live_title(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_live_title(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_live_title(inputs)
	return en_us2_quick_workout_live_title(inputs)
});
export { quick_workout_live_title as "quick-workout.live_title" }